import { t } from 'i18next';
import { downloadFileStr, formatDisplayDate } from './func';
import { getDeliveryDate } from './dateTime';

export const formatQuotesReport = (data) => {
  // eslint-disable-next-line max-len
  const header = `${t('ReportHeaderAddressFromCity')},${t('ReportHeaderAddressFromProvinceCode')},${t('ReportHeaderAddressFromCountryCode')},${t('ReportHeaderAddressFromPostalCode')},${t('ReportHeaderAddressToCity')},${t('ReportHeaderAddressToProviceCode')},${t('ReportHeaderAddressToCountryCode')},${t('ReportHeaderAddressToPostalCode')},${t('ReportHeaderAmountValue')},${t('ReportHeaderAmountCurrencyCode')},${t('ReportHeaderCreateDate')},${t('ReportHeaderQuoteNumber')},${t('ReportHeaderQuoteType')},${t('ReportHeaderStatus')},${t('ReportHeaderPieces')},${t('ReportHeaderWeight')}`;
  return data.reduce((output, item) => {
    const {
      addressFrom, addressTo, amount, createDate, quoteNumber, quoteType, status, weight, pieces,
    } = item;
    let outputData = output;
    // eslint-disable-next-line max-len
    outputData += `\r\n${addressFrom.city},${addressFrom.provinceCode},${addressFrom.countryCode},${addressFrom.postalCode},${addressTo.city},${addressTo.provinceCode},${addressTo.countryCode},${addressTo.postalCode},${amount.value},${amount.currencyCode},${formatDisplayDate(createDate)},${quoteNumber},${quoteType},${status},${pieces || ''},${weight.value}`;
    return outputData;
  }, header);
};

export const formatInvoicesReport = (data) => {
  // eslint-disable-next-line max-len
  const header = `${t('ReportHeaderAccountNumber')},${t('ReportHeaderBalanceDue')},${t('ReportHeaderBalanceDueCurrencyCode')},${t('ReportHeaderCustomerName')},${t('ReportHeaderDueDate')},${t('ReportHeaderInvoiceAmount')},${t('ReportHeaderInvoiceAmountCurrencyCode')},${t('ReportHeaderInvoiceDate')},${t('ReportHeaderInvoiceNumber')}`;

  return data.reduce((output, item) => {
    const {
      accountNumber, balanceDue, customerName, dueDate, invoiceAmount, invoiceDate, invoiceNumber,
    } = item;
    let outputData = output;
    // eslint-disable-next-line max-len
    outputData += `\r\n${accountNumber},${balanceDue.value},${balanceDue.currencyCode},${customerName},${formatDisplayDate(dueDate)},${invoiceAmount.value},${invoiceAmount.currencyCode},${formatDisplayDate(invoiceDate)},${invoiceNumber}`;
    return outputData;
  }, header);
};

export const formatShipmentsReport = (data) => {
  // eslint-disable-next-line max-len
  const header = `${t('ReportHeaderBillOfLandingImage')},${t('ReportHeaderBillOfLandingNumber')},${t('ReportHeaderCharge')},${t('ReportHeaderDestinationTerminal')},${t('ReportHeaderAddressFromName')},${t('ReportHeaderAddressFromCity')},${t('ReportHeaderAddressFromProvinceCode')},${t('ReportHeaderAddressFromCountryCode')},${t('ReportHeaderAddressFromPostalCode')},${t('ReportHeaderImageAvailable')},${t('ReportHeaderOriginTerminal')},${t('ReportHeaderPieces')},${t('ReportHeaderPostalOfficeNumber')},${t('ProNumber')},${t('ReportHeaderProofOfDeliveryImage')},${t('ReportHeaderShipDate')},${t('ReportHeaderDeliveryDate')},${t('ReportHeaderStatus')},${t('ReportHeaderAddressToName')},${t('ReportHeaderAddressToCity')},${t('ReportHeaderAddressToProviceCode')},${t('ReportHeaderAddressToCountryCode')},${t('ReportHeaderAddressToPostalCode')},${t('ReportHeaderWeight')}`;

  return data.reduce((output, item) => {
    const {
      billOfLadingImage,
      bolNumber,
      charge,
      destinationTerminal,
      from,
      isImageAvailable,
      originTerminal,
      pieces,
      poNumber,
      probillNumber,
      proofOfDeliveryImage,
      shipDate,
      deliveryDate,
      deliveryDateType,
      status,
      to,
      weight,
    } = item;
    let outputData = output;
    // eslint-disable-next-line max-len
    outputData += `\r\n${billOfLadingImage},${bolNumber},${charge.value},${destinationTerminal},${from.name},${from.city},${from.provinceCode},${from.countryCode},${from.postalCode},${isImageAvailable},${originTerminal},${pieces},${poNumber},${probillNumber},${proofOfDeliveryImage},${getDeliveryDate({ deliveryDate: shipDate, deliveryDateType: 'default' })},${getDeliveryDate({ deliveryDate, deliveryDateType })},${status},${to.name},${to.city},${to.provinceCode},${to.countryCode},${to.postalCode},${weight.value}`;
    return outputData;
  }, header);
};

export const formatPickupsReport = (data) => {
  // eslint-disable-next-line max-len
  const header = `${t('ReportHeaderCreateDate')},${t('ReportHeaderDeliveryAddress')},${t('OrderNumber')},${t('ReportHeaderPickupAddress')},${t('ReportHeaderPickupDate')},${t('ReportHeaderStatus')}`;
  return data.reduce((output, item) => {
    const {
      createdOn, deliveryAddress, orderNumber, pickupAddress, pickupDate, status,
    } = item;
    let outputData = output;
    // eslint-disable-next-line max-len
    outputData += `\r\n${formatDisplayDate(createdOn)},"${deliveryAddress || ''}",${orderNumber},"${pickupAddress || ''}",${formatDisplayDate(pickupDate)},${status}`;
    return outputData;
  }, header);
};

export const formatContactReports = (data) => {
  // Column order: Nickname, Contact Name, Contact Type, Email Address, Contact Company Name,
  // Address Line 1, Address Line 2, City, Province/State Code, Postal Code, Country Code,
  // Phone Number, Phone Extension
  // Uses semicolons as delimiter to match import validation (validateCsvContent expects semicolons)
  const header = [
    t('ContactReportNickname'),
    t('ContactReportContactName'),
    t('ContactReportContactType'),
    t('ContactReportEmailAddress'),
    t('ContactReportContactCompanyName'),
    t('ContactReportAddressLine1'),
    t('ContactReportAddressLine2'),
    t('ContactReportCity'),
    t('ContactReportProvinceStateCode'),
    t('ContactReportPostalCode'),
    t('ContactReportCountryCode'),
    t('ContactReportPhoneNumber'),
    t('ContactReportPhoneExtension'),
  ].join(';');

  return data.reduce((output, item) => {
    const {
      nickname,
      contactName,
      contactType,
      emailAddress,
      companyName,
      address1,
      address2,
      city,
      provinceCode,
      postalCode,
      countryCode,
      phoneNumber,
      phoneExtension,
    } = item;
    const rowValues = [
      nickname || '',
      contactName || '',
      contactType || '',
      emailAddress || '',
      companyName || '',
      address1 || '',
      address2 || '',
      city || '',
      provinceCode || '',
      postalCode || '',
      countryCode || '',
      phoneNumber || '',
      phoneExtension || '',
    ].map((val) => `"${val.toString().replace(/"/g, '""')}"`);
    return `${output}\r\n${rowValues.join(';')}`;
  }, header);
};

export const generateContactImportTemplate = () => {
  // Generate import template with the same column order as export
  // Uses semicolons as delimiter to match the import validation logic
  const header = [
    t('ContactReportNickname'),
    t('ContactReportContactName'),
    t('ContactReportContactType'),
    t('ContactReportEmailAddress'),
    t('ContactReportContactCompanyName'),
    t('ContactReportAddressLine1'),
    t('ContactReportAddressLine2'),
    t('ContactReportCity'),
    t('ContactReportProvinceStateCode'),
    t('ContactReportPostalCode'),
    t('ContactReportCountryCode'),
    t('ContactReportPhoneNumber'),
    t('ContactReportPhoneExtension'),
  ].join(';');

  return header;
};

export const DownloadFileNames = {
  QuotesReport: 'quoteReport.csv',
  ShipmentsInProgressReport: 'shipmentsInProgressReport.csv',
  ShipmentsCompletedReport: 'shipmentsCompletedReport.csv',
  InvoicesReport: 'invoiceReport.csv',
  ShipmentsReport: 'shipmentsReport.csv',
  PickupsReport: 'pickupsReport.csv',
  ContactsReport: 'contactReport.csv',
};

export const mimeType = 'text/plain';

export const downloadContactImportTemplate = () => {
  const template = generateContactImportTemplate();
  downloadFileStr('Import_Contacts_Template.csv', template, mimeType);
};

export const downloadReport = (fileName, formatFunction, data) => {
  if (fileName && formatFunction && data && data.length > 0) {
    const formattedData = formatFunction(data);
    downloadFileStr(fileName, formattedData, mimeType);
  }
};

/**
 * Decodes a base64 CSV string, removes rows where the "Status" column
 * equals "Order canceled", then re-encodes to base64.
 */
export const filterCanceledOrdersFromCsvBase64 = (fileDataAsBase64) => {
  if (!fileDataAsBase64) return fileDataAsBase64;

  const csvText = atob(fileDataAsBase64);
  const rows = csvText.split('\r\n');

  if (rows.length < 2) return fileDataAsBase64;

  const header = rows[0];
  const headerCols = header.split(',');
  const statusColIndex = headerCols.findIndex(
    (col) => col.trim().toLowerCase() === 'status',
  );

  if (statusColIndex === -1) return fileDataAsBase64;

  const filteredRows = rows.filter((row, index) => {
    if (index === 0) return true;
    if (row === '') return true;
    const cols = row.split(',');
    return (cols[statusColIndex] || '').trim().toLowerCase() !== 'order canceled';
  });

  const filteredCsv = filteredRows.join('\r\n');
  return btoa(unescape(encodeURIComponent(filteredCsv)));
};
